import React, { Component, PropTypes } from 'react';
import { Dialog, FlatButton } from 'material-ui';
import { connect } from 'react-redux';


class FreeContractForContractorDialog extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.freeContractDialog.get('open') || this.props.freeContractDialog.get('open');
  }

  render() {
    const {
      freeContractDialog,
      freeContractsLeft,
      closeDialog,
      updateFreeContractsUsed,
    } = this.props;
    const open = freeContractDialog.get('open');
    const contractUrl = freeContractDialog.get('url');
    const contractId = freeContractDialog.get('contractId');
    const goToUpgradePage = () => Promise.resolve(closeDialog()).then(_ => this.context.router.push('/billing/free-trial-used'));
    const useFreeContract = url => Promise.resolve(updateFreeContractsUsed(contractId)).then(_ => this.context.router.push(url));
    const message = freeContractsLeft ? `You have ${freeContractsLeft} free contract${freeContractsLeft === 1 ? 's' : ''} left.
                     To continue you can use one of your free trial contracts.`
                      :
      `You have used all of the contracts in your free trial. You can continue to download as many contracts as you wish;
      however to access the full benefits of TourConnect, like online contract versions, tracking contract changes, or supplier messaging, please upgrade to the Connected Plan.`;
    const dialogActions = [
      <FlatButton
        label="Cancel"
        onTouchTap={closeDialog}
        secondary
      />,
      <FlatButton
        label={freeContractsLeft ? 'Use Free Contract' : 'Upgrade'}
        onTouchTap={freeContractsLeft ?
                      () => useFreeContract(contractUrl) :
                      goToUpgradePage
        }
        primary
      />,
    ];

    return (
      <Dialog
        title={freeContractsLeft ? 'Use Free Contract to Continue' : 'Upgrade to Continue'}
        actions={dialogActions}
        open={open}
        contentStyle={{ margin: '0 auto', width: '350px', verticalAlign: 'center' }}
        bodyStyle={{ paddingBottom: '12px', paddingTop: '12px' }}
        actionsContainerStyle={{ paddingTop: '0px' }}
      >
        {message}
      </Dialog>
    );
  }
}

const mapStateToProps = ({ contracting, user }) => ({
  freeContractDialog: contracting.freeContractDialog,
  freeContractsLeft: user.get('freeContractsLeft'),
});

const mapDispatchToProps = dispatch => ({
  closeDialog: () => dispatch({ type: 'CLOSE_FREE_CONTRACT_DIALOG' }),
  updateFreeContractsUsed: contractId => dispatch({ type: 'USED_AS_FREE_BY_CONTRACTOR', payload: { contractId } }),
});

FreeContractForContractorDialog.propTypes = {
  closeDialog: PropTypes.func,
  createFolder: PropTypes.func,
  handleAddFolderInput: PropTypes.func,
  updateFreeContractsUsed: PropTypes.func,
  freeContractDialog: PropTypes.object,
  freeContractsLeft: PropTypes.number,
  open: PropTypes.bool,
  input: PropTypes.string,
};
FreeContractForContractorDialog.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(FreeContractForContractorDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/free-contract-contractor-dialog.js